var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"flex flex-row border-b border-main-3"},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.name,staticClass:"flex flex-row items-center text-left px-6 py-2 border-b-4 transition-colors duration-200",class:{
      'border-dark': tab.name === _vm.current,
      'border-transparent': tab.name !== _vm.current,
    },on:{"click":function($event){return _vm.onTabClick(tab)}}},[_c('Icon',{staticClass:"w-5 h-5 mr-2",class:{
        'text-dark': tab.name === _vm.current,
        'text-gray-700': tab.name !== _vm.current,
      },attrs:{"icon":tab.icon}}),_c('p',{staticClass:"text-lg",class:{
        'text-dark': tab.name === _vm.current,
        'text-gray-700': tab.name !== _vm.current,
      }},[_vm._v(" "+_vm._s(tab.name)+" "),(_vm.$is_int(tab.count))?_c('span',[_vm._v("("+_vm._s(tab.count)+")")]):_vm._e()])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }